import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrDataRetrievalText = ({
  text,
  loadingText,
  dataIsLoading,
}) => (
  <SrBox>
    <SrText
      font='greycliff'
      whiteSpace='nowrap'
    >
      {dataIsLoading ? loadingText : text}
    </SrText>
  </SrBox>
);

SrDataRetrievalText.propTypes = {
  text: PropTypes.string,
  loadingText: PropTypes.string,
  dataIsLoading: PropTypes.bool,
};

SrDataRetrievalText.defaultProps = {
  text: 'No data available at this time',
  loadingText: 'Loading data...',
};

SrDataRetrievalText.displayName = 'SrDataRetrievalText';

export default SrDataRetrievalText;
